import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "store";

interface AccountState {
  blinkUsername: boolean;
}

const initialState: AccountState = {
  blinkUsername: false,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setBlinkUsername: (state, action) => {
      state.blinkUsername = action.payload;
    },
  },
});

export const { setBlinkUsername } = accountSlice.actions;

// Selectors
export const selectBlinkUsername = (state: RootState) => state.account.blinkUsername;

export default accountSlice;
